import React from 'react';
import { toPersianDigits } from '../../utils/timeUtils.js';

export interface TabRequestItem {
  id: string;
  songTitle: string;
  artist: string;
  tuning: string;
  referenceUrl?: string | null;
  status?: string;
  createdAt?: string;
  voteCount: number;
  hasVoted?: boolean;
}

export interface RequestRowProps {
  request: TabRequestItem;
  isVoting?: boolean;
  onVote: (requestId: string) => void;
  isLast?: boolean;
  isHighlighted?: boolean;
}

export const RequestRow: React.FC<RequestRowProps> = ({
  request,
  isVoting = false,
  onVote,
  isLast = false,
  isHighlighted = false
}) => {
  return (
    <div
      id={`request-row-${request.id}`}
      data-testid={`request-row-${request.id}`}
      className={`px-4.5 py-3.5 flex items-center gap-3 transition-colors ${
        isHighlighted ? 'bg-primary/20 ring-1 ring-primary' : 'hover:bg-base-200/40'
      } ${
        isLast ? '' : 'border-b border-base-300'
      }`}
    >
      <div className="flex-1 min-w-0">
        <p
          dir="ltr"
          className="text-sm font-semibold text-base-content text-right truncate"
        >
          {request.songTitle}
        </p>
        <p className="text-xs text-base-content/60 mt-0.5 truncate text-start">
          <span dir="ltr">{request.artist}</span> · {toPersianDigits(request.voteCount)} رأی
        </p>
      </div>
      <button
        type="button"
        dir="ltr"
        onClick={() => onVote(request.id)}
        disabled={isVoting}
        aria-pressed={request.hasVoted}
        className={`size-8 px-0 rounded-xl border font-semibold text-xs transition-colors shrink-0 select-none ltr-nums flex items-center justify-center ${
          request.hasVoted
            ? 'border-primary bg-primary/15 text-primary-soft'
            : 'border-base-300 bg-transparent text-base-content/80 hover:bg-base-300/40'
        }`}
        data-testid={`request-vote-button-${request.id}`}
      >
        <span>+</span><span>۱</span>
      </button>
    </div>
  );
};
